import { render } from "./linkCard.vue?vue&type=template&id=36fb5ec9&scoped=true"
import script from "./linkCard.vue?vue&type=script&lang=js"
export * from "./linkCard.vue?vue&type=script&lang=js"

import "./linkCard.vue?vue&type=style&index=0&id=36fb5ec9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fb5ec9"]])

export default __exports__